import styled from 'styled-components';
import JobTitle from 'gatsby-theme-employees/src/components/preview/job-title';

export default styled(JobTitle)`
  color: ${({ theme }) => theme.gray04};
  margin-bottom: 1rem;
`;
